import { useMutation } from 'react-query'
import { accountsService } from 'src/services/accounts.service'
import { IAccountCreateCheckDto } from 'src/types'

export const useAccountCreateCheck = () => {
  return useMutation((dto: IAccountCreateCheckDto) => accountsService.createAccountCheck(dto))
}
